import _ from '@/utils/lodash-optimized'
import { Component } from 'react'
import { connect } from 'react-redux'
import IssueMapper from 'shared_src/mappings/issue'

import { getRows, countIssuesByStatus } from '../../../lib/issues'
import { uid } from '../../igao/utils'
import { CircularProgress } from '../../shared/NarusMaterial'

import { updateIssue } from './actions'
import { IgaoComponent, PatientFolderComponent } from './components/IGAO'
import './styles.scss'

class IGAO extends Component {
  constructor (props) {
    super(props)
    this.state = {
      issueFilters: [ 'in-progress', 'not-started' ]
    }
    this.toggleIssueFilter = this.toggleIssueFilter.bind(this)
    this.onFormSave = this.onFormSave.bind(this)
  }

  onFormSave (data) {
    const { currentUser, encounterId, dispatch } = this.props
    const carePlanAndGoal = IssueMapper.mapFormToIssue({
      issue: data,
      currentUser,
      encounterId,
      uid
    })
    dispatch(updateIssue(carePlanAndGoal))
  }

  toggleIssueFilter (filter) {
    const { issueFilters } = this.state
    let newFilters = issueFilters
    if (newFilters.includes(filter)) {
      console.log(filter)
      newFilters = newFilters.filter((f) => f !== filter)
    } else {
      newFilters.push(filter)
    }
    this.setState({
      issueFilters: newFilters
    })
  }

  render () {
    const {
      loading,
      careplans,
      goals,
      encounterId,
      esasData,
      patientFolder,
      dispatch,
      currentUser
    } = this.props

    if (loading) {
      return (
        <CircularProgress />
      )
    }

    const { issueFilters } = this.state
    const rows = getRows({
      issueFilters,
      careplans,
      goals,
      encounterId,
      esasData
    })
    if (patientFolder) {
      return (
        <PatientFolderComponent
          dispatch={dispatch}
          rows={rows}
        />
      )
    }
    const issueCounts = countIssuesByStatus({ careplans })
    return (
      <div>
        <IgaoComponent
          dispatch={dispatch}
          filters={issueFilters}
          updateFilters={this.toggleIssueFilter}
          rows={rows}
          onSave={this.onFormSave}
          currentUser={currentUser}
          issueCounts={issueCounts}
        />
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  loading: redux?.patient?.loading ?? false,
  sortState: redux.crudTable,
  esasData: redux.esas.bannerData,
  currentUser: redux.users.current_user,
  patientId: redux.patient.id,
    careplans: redux?.patient?.compartment?.CarePlan ?? {},
    goals: redux?.patient?.compartment?.Goal ?? {},
    encounterId: redux?.encounter?.encounter?.id
})

export default connect(mapStateToProps)(IGAO)
